import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AdminSidebar } from './Dashboard';
import api from '../../services/api';

export default function AdminSolicitacaoDetalhe() {
  const { id } = useParams();
  const nav    = useNavigate();
  const [sol, setSol]               = useState(null);
  const [obs, setObs]               = useState('');
  const [salvando, setSalvando]     = useState(false);
  const [modalAjuste, setModalAjuste] = useState(false);
  const [msgAjuste, setMsgAjuste]   = useState('');

  useEffect(() => {
    api.get(`/admin/solicitacoes/${id}`)
      .then(({ data }) => { setSol(data); setObs(data.observacoes_internas || ''); })
      .catch(() => nav('/admin/solicitacoes'));
  }, [id]);

  const atualizar = async (status, extra = {}) => {
    setSalvando(true);
    try {
      await api.patch(`/admin/solicitacoes/${id}/status`, { status, observacoes: obs, ...extra });
      nav('/admin/solicitacoes');
    } finally { setSalvando(false); }
  };

  const enviarAjuste = async () => {
    if (!msgAjuste.trim()) return;
    await atualizar('ajuste_solicitado', { mensagem_ajuste: msgAjuste });
  };

  if (!sol) return <div className="admin-layout"><AdminSidebar /><div className="admin-content"><p className="carregando">Carregando…</p></div></div>;

  const dados = typeof sol.dados_veiculo === 'string' ? JSON.parse(sol.dados_veiculo) : sol.dados_veiculo || {};
  const campos = Object.entries(dados).filter(([,v]) => v !== '' && v !== null && v !== undefined && v !== false);

  const ActionBtn = ({ label, onClick, style }) => (
    <button onClick={onClick} disabled={salvando} className="btn btn-sm"
      style={{ justifyContent:'center', fontWeight:900, ...style }}>
      {label}
    </button>
  );

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">

        {/* Modal Solicitar Ajuste */}
        {modalAjuste && (
          <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:20 }}
            onClick={e => e.target === e.currentTarget && setModalAjuste(false)}>
            <div style={{ background:'#fff', borderRadius:12, padding:'32px 36px', width:'100%', maxWidth:520 }}>
              <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:20, marginBottom:8 }}>Solicitar ajuste ao anunciante</h2>
              <p style={{ fontSize:13, color:'var(--ink-muted)', marginBottom:20, lineHeight:1.6 }}>
                Descreva claramente quais ajustes são necessários. Esta mensagem será exibida para o anunciante em "Meus Anúncios".
              </p>
              <textarea
                value={msgAjuste}
                onChange={e => setMsgAjuste(e.target.value)}
                rows={6}
                placeholder="Ex: As fotos laterais estão cortadas. Por favor, reenvie com o veículo completo enquadrado. Também corrija o preço informado…"
                style={{ width:'100%', padding:'12px 14px', border:'1px solid var(--border)', borderRadius:'var(--r-sm)', fontSize:14, resize:'vertical', fontFamily:'inherit', boxSizing:'border-box' }}
                autoFocus
              />
              <div style={{ display:'flex', gap:12, marginTop:20, justifyContent:'flex-end' }}>
                <button className="btn btn-outline btn-sm" onClick={() => setModalAjuste(false)}>Cancelar</button>
                <button
                  className="btn btn-sm"
                  style={{ background:'#c85718', color:'#fff', border:'none', fontWeight:900, opacity: msgAjuste.trim() ? 1 : 0.5 }}
                  disabled={!msgAjuste.trim() || salvando}
                  onClick={enviarAjuste}
                >
                  {salvando ? 'Enviando…' : '⚠ Enviar solicitação de ajuste'}
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="admin-header">
          <h1 className="admin-title">Solicitação #{sol.id}</h1>
          <button onClick={() => nav('/admin/solicitacoes')} className="btn btn-outline btn-sm">← Voltar</button>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 320px', gap:24 }}>
          {/* Esquerda */}
          <div>
            <div className="card" style={{ padding:28, marginBottom:18 }}>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, marginBottom:18 }}>Dados do anunciante</h3>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                {[['Nome', sol.nome_anunciante], ['WhatsApp', sol.whatsapp_anunciante], ['E-mail', sol.email_anunciante||'—'], ['Cidade/UF', `${sol.cidade_anunciante||'—'} / ${sol.estado_anunciante||'—'}`]].map(([k,v]) => (
                  <div key={k}>
                    <div style={{ fontSize:9, letterSpacing:1.6, textTransform:'uppercase', color:'var(--rust)', fontWeight:900, marginBottom:4 }}>{k}</div>
                    <div style={{ fontSize:14, fontWeight:700 }}>{v}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="card" style={{ padding:28, marginBottom:18 }}>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, marginBottom:18 }}>Dados do veículo</h3>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                {campos.map(([k, v]) => (
                  <div key={k} style={{ fontSize:13 }}>
                    <div style={{ fontSize:9, letterSpacing:1.2, textTransform:'uppercase', color:'var(--ink-muted)', marginBottom:2 }}>{k.replace(/_/g,' ')}</div>
                    <div style={{ fontWeight:700 }}>{typeof v === 'boolean' ? (v ? 'Sim' : 'Não') : String(v)}</div>
                  </div>
                ))}
              </div>
            </div>

            {sol.fotos?.length > 0 && (
              <div className="card" style={{ padding:28 }}>
                <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, marginBottom:16 }}>Fotos ({sol.fotos.length})</h3>
                <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:10 }}>
                  {sol.fotos.map(f => (
                    <a key={f.id} href={f.url} target="_blank" rel="noopener noreferrer">
                      <img src={f.url} alt={f.tipo} style={{ width:'100%', height:90, objectFit:'cover', borderRadius:'var(--r-sm)', border:'1px solid var(--border)' }} />
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Direita */}
          <div>
            <div className="card" style={{ padding:24, position:'sticky', top:20 }}>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, marginBottom:16 }}>Análise Heritage</h3>

              <div style={{ marginBottom:6, fontSize:10, letterSpacing:1.6, textTransform:'uppercase', color:'var(--rust)', fontWeight:900 }}>Status atual</div>
              <div style={{ background:'var(--cream-dark)', borderRadius:'var(--r-sm)', padding:'10px 14px', fontSize:13, fontWeight:700, marginBottom:18 }}>{sol.status?.replace(/_/g,' ')}</div>

              {sol.mensagem_ajuste && (
                <div style={{ background:'rgba(200,87,24,.08)', border:'1px solid rgba(200,87,24,.3)', borderRadius:'var(--r-sm)', padding:'12px 14px', marginBottom:18, fontSize:13 }}>
                  <div style={{ fontSize:10, letterSpacing:1.2, textTransform:'uppercase', color:'#c85718', fontWeight:900, marginBottom:6 }}>Ajuste solicitado anteriormente</div>
                  <div style={{ color:'var(--ink)', lineHeight:1.6 }}>{sol.mensagem_ajuste}</div>
                </div>
              )}

              <div className="form-group">
                <label>Observações internas</label>
                <textarea value={obs} onChange={e => setObs(e.target.value)} rows={4} placeholder="Registre observações, justificativa ou instruções…" />
              </div>

              <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                <ActionBtn label="✓ Aprovar e publicar" onClick={() => atualizar('aprovado')} style={{ background:'#1e7d47', color:'#fff', border:'none' }} />
                <ActionBtn label="⚠ Solicitar ajuste"   onClick={() => setModalAjuste(true)} style={{ background:'#c85718', color:'#fff', border:'none' }} />
                <ActionBtn label="✗ Recusar"            onClick={() => atualizar('recusado')} style={{ background:'#be2e2e', color:'#fff', border:'none' }} />
                <ActionBtn label="Marcar em análise"    onClick={() => atualizar('em_analise')} style={{ background:'transparent', border:'1px solid var(--border)', color:'var(--ink)' }} />
              </div>

              {sol.aceite_termos_em && (
                <p style={{ fontSize:11, color:'var(--ink-muted)', marginTop:16, lineHeight:1.5 }}>
                  Termos aceitos em {new Date(sol.aceite_termos_em).toLocaleDateString('pt-BR')}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
